module.exports = __webpack_public_path__ + "img/電気回路_4_1_5.a8d2ed68.png";